<div class="flex justify-end mb-5">
	<app-button size="small" (onClick)="download()"
		>Download Documents</app-button
	>
</div>
<table
	mat-table
	[dataSource]="dataSource"
	[trackBy]="trackById"
	matSort
	class="animate w-full app-table"
>
	<ng-container matColumnDef="name">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
		<td mat-cell *matCellDef="let element">{{ element.name }}</td>
	</ng-container>

	<ng-container matColumnDef="uploaded">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Uploaded</th>
		<td mat-cell *matCellDef="let element">
			{{ element.uploaded }}
		</td>
	</ng-container>

	<ng-container matColumnDef="source">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Source</th>
		<td mat-cell *matCellDef="let element">
			{{ element.source }}
		</td>
	</ng-container>

	<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
	<tr
		mat-row
		*matRowDef="let row; columns: displayedColumns"
		class="animate cursor-pointer"
		(click)="openFile(row)"
	></tr>
</table>
